
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoPurOrderAppEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoPurOrderAppRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoPurOrderAppRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
